// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogCard_card__7jw1X","finger":"BlogCard_finger__PWr7d"};